/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Edit_Form_TitleInputs */

const en_tags_manager_edit_form_title = /** @type {(inputs: Tags_Manager_Edit_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag Edit Form`)
};

const fr_tags_manager_edit_form_title = /** @type {(inputs: Tags_Manager_Edit_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulaire d'edition des tags`)
};

const de_tags_manager_edit_form_title = /** @type {(inputs: Tags_Manager_Edit_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag-Bearbeitungsformular`)
};

const it_tags_manager_edit_form_title = /** @type {(inputs: Tags_Manager_Edit_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modulo di modifica tag`)
};

const ru_tags_manager_edit_form_title = /** @type {(inputs: Tags_Manager_Edit_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма редактирования тега`)
};

const es_tags_manager_edit_form_title = /** @type {(inputs: Tags_Manager_Edit_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulario de edición de etiquetas`)
};

const zh_cn2_tags_manager_edit_form_title = /** @type {(inputs: Tags_Manager_Edit_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签编辑表单`)
};

const ja_tags_manager_edit_form_title = /** @type {(inputs: Tags_Manager_Edit_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグ編集フォーム`)
};

const hi_tags_manager_edit_form_title = /** @type {(inputs: Tags_Manager_Edit_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग संपादन फ़ॉर्म`)
};

const pt_pt2_tags_manager_edit_form_title = /** @type {(inputs: Tags_Manager_Edit_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulário de edição de tags`)
};

/**
* | output |
* | --- |
* | "Tag Edit Form" |
*
* @param {Tags_Manager_Edit_Form_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_edit_form_title = /** @type {((inputs?: Tags_Manager_Edit_Form_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Edit_Form_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_edit_form_title(inputs)
	if (locale === "de") return de_tags_manager_edit_form_title(inputs)
	if (locale === "it") return it_tags_manager_edit_form_title(inputs)
	if (locale === "ru") return ru_tags_manager_edit_form_title(inputs)
	if (locale === "es") return es_tags_manager_edit_form_title(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_edit_form_title(inputs)
	if (locale === "ja") return ja_tags_manager_edit_form_title(inputs)
	if (locale === "hi") return hi_tags_manager_edit_form_title(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_edit_form_title(inputs)
	return en_tags_manager_edit_form_title(inputs)
});